import { Converter } from '../types/converter';

export const powerConverter: Converter = {
  id: 'power',
  name: 'Power Converter',
  icon: 'Power',
  categories: ['common', 'engineering', 'electricity'],
  units: [
    // SI base unit and decimal multiples
    { name: 'Watt', symbol: 'W', factor: 1 },
    { name: 'Exawatt', symbol: 'EW', factor: 1e18 },
    { name: 'Petawatt', symbol: 'PW', factor: 1e15 },
    { name: 'Terawatt', symbol: 'TW', factor: 1e12 },
    { name: 'Gigawatt', symbol: 'GW', factor: 1e9 },
    { name: 'Megawatt', symbol: 'MW', factor: 1e6 },
    { name: 'Kilowatt', symbol: 'kW', factor: 1e3 },
    { name: 'Hectowatt', symbol: 'hW', factor: 1e2 },
    { name: 'Dekawatt', symbol: 'daW', factor: 10 },
    { name: 'Deciwatt', symbol: 'dW', factor: 0.1 },
    { name: 'Centiwatt', symbol: 'cW', factor: 0.01 },
    { name: 'Milliwatt', symbol: 'mW', factor: 1e-3 },
    { name: 'Microwatt', symbol: 'μW', factor: 1e-6 },
    { name: 'Nanowatt', symbol: 'nW', factor: 1e-9 },
    { name: 'Picowatt', symbol: 'pW', factor: 1e-12 },
    { name: 'Femtowatt', symbol: 'fW', factor: 1e-15 },
    { name: 'Attowatt', symbol: 'aW', factor: 1e-18 },

    // Horsepower variants
    { name: 'Horsepower (UK)', symbol: 'hp (UK)', factor: 745.69987158227022 },
    { name: 'Horsepower (550 ft·lbf/s)', symbol: 'hp', factor: 745.69987158227022 },
    { name: 'Horsepower (metric)', symbol: 'hp (metric)', factor: 735.49875 },
    { name: 'Horsepower (boiler)', symbol: 'hp (boiler)', factor: 9809.5 },
    { name: 'Horsepower (electric)', symbol: 'hp (electric)', factor: 746 },
    { name: 'Horsepower (water)', symbol: 'hp (water)', factor: 746.043 },
    { name: 'Pferdestärke', symbol: 'PS', factor: 735.49875 },

    // BTU variants
    { name: 'BTU (IT)/hour', symbol: 'Btu/h', factor: 0.29307107017222222 },
    { name: 'BTU (IT)/minute', symbol: 'Btu/min', factor: 17.584264210333333 },
    { name: 'BTU (IT)/second', symbol: 'Btu/s', factor: 1055.05585262 },
    { name: 'BTU (th)/hour', symbol: 'Btu (th)/h', factor: 0.29251200000000003 },
    { name: 'BTU (th)/minute', symbol: 'Btu (th)/min', factor: 17.550720000000002 },
    { name: 'BTU (th)/second', symbol: 'Btu (th)/s', factor: 1053.0432 },
    { name: 'MBtu (IT)/hour', symbol: 'MBtu/h', factor: 293.07107017222222 },
    { name: 'MBH', symbol: 'MBH', factor: 293.07107017222222 },

    // Refrigeration
    { name: 'Ton (refrigeration)', symbol: 'TR', factor: 3516.8528421666665 },

    // Calorie variants
    { name: 'Kilocalorie (IT)/hour', symbol: 'kcal/h', factor: 1.163 },
    { name: 'Kilocalorie (IT)/minute', symbol: 'kcal/min', factor: 69.78 },
    { name: 'Kilocalorie (IT)/second', symbol: 'kcal/s', factor: 4186.8 },
    { name: 'Kilocalorie (th)/hour', symbol: 'kcal (th)/h', factor: 1.162222222222222 },
    { name: 'Kilocalorie (th)/minute', symbol: 'kcal (th)/min', factor: 69.73333333333333 },
    { name: 'Kilocalorie (th)/second', symbol: 'kcal (th)/s', factor: 4184 },
    { name: 'Calorie (IT)/hour', symbol: 'cal/h', factor: 0.001163 },
    { name: 'Calorie (IT)/minute', symbol: 'cal/min', factor: 0.06978 },
    { name: 'Calorie (IT)/second', symbol: 'cal/s', factor: 4.1868 }
  ]
};
